import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export function setPurchaseToReschedule(
  purchase: core.PastPurchase,
  ticketGroup: core.TicketGroup
): BaseTockAction {
  return {
    type: AppConstants.RESCHEDULE_SET_RESCHEDULED,
    payload: {
      purchase,
      ticketGroup,
    },
  };
}

export function clearPurchaseToReschedule(): BaseTockAction {
  return {
    type: AppConstants.RESCHEDULE_CLEAR_RESCHEDULED,
  };
}

export interface RescheduleTo {
  rescheduleToTicketGroup?: core.TicketGroup;
  rescheduleDateTime?: string;
  requestedTableId?: number[];
  newNumTickets?: number;
  newTicketTypeId?: number;
}

export function setRescheduleTo(rescheduleTo: RescheduleTo) {
  return {
    type: AppConstants.RESCHEDULE_SET_RESCHEDULE_TO,
    payload: rescheduleTo,
  };
}

export function clearRescheduleTo() {
  return {
    type: AppConstants.RESCHEDULE_CLEAR_RESCHEDULE_TO,
  };
}
